<template>
    <div class="accordion js-accordion">
        <slot></slot>
    </div>
</template>
<script>
export default
    {


    }

</script>